module.exports = __webpack_public_path__ + "static/media/bg8.dc7d3445.jpg";